import ApiService from "./api.service";
export default class PromotionAssignementService extends ApiService {
    static base_url = `${super.base_url}/promotions_assignements`;
}
